<template>
  <Modal class="confirmationModal members" :title="$t('app.modals.revokeMember.title')" :isOpen="isOpen" @close="emits('close')" :buttons="[]">
    <template #extra>
      <div class="round-icon">
        <i class="bi bi-exclamation-triangle-fill" />
      </div>
      <div class="title-block">
        <i18n-t keypath="app.modals.revokeMember.subtitle">
          <template #member>
            <span class="primary-color" v-if="member.candidate_id" v-safe-html="`${member.candidate.first_name} ${member.candidate.last_name}`" />
            <span class="primary-color" v-else v-safe-html="member.pending_first_name && member.pending_last_name ? `${member.pending_first_name} ${member.pending_last_name}` : member.pending_email" />
          </template>
        </i18n-t>
      </div>
      <p class="under-text">
        {{ $t("app.modals.revokeMember.text") }}
      </p>
      <div class="btn-container">
        <Button class="primary" :label="$t('app.modals.revokeMember.buttons.confirm')" @click="emits('confirm')" />
        <Button class="secondary outline" :label="$t('app.modals.revokeMember.buttons.cancel')" @click="emits('close')" />
      </div>
    </template>
  </Modal>
</template>

<script setup>
import Modal from "@/components/global/Modal.vue";

const emits = defineEmits(["close", "confirm"]);

defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  member: {
    type: Object,
    required: true,
  },
});
</script>
